import React from 'react'

type Props = {
    className?      : string

    option          : any

    isHighlighted?  : boolean
    isSelected?     : boolean

    onClick         : func
}

// extends React.Component is required because of reference in parent
export default class FieldStatus_MultiselectPopoverOption extends React.Component<Props> {

    onClick = () => {this.props.onClick(this.props.option)}

    render() {
        const hasValue = !_.isNil(this.props.option.value)

        const classes = Classes('option pill', {
            'highlighted': this.props.isHighlighted
        })

        const valueClasses = Classes({
            'ui5-status-list'                           : hasValue,
            ['status-c{0}'.f(this.props.option.color)]  : hasValue && !!this.props.option.color,
        })

        return (
            <div className={classes} onClick={this.onClick}>
                {hasValue &&
                    <div className={Classes("ui5-cb fl-no-shrink s-16 m-r-10", this.props.className, {selected: this.props.isSelected})}/>}
                <div className={valueClasses}>{this.props.option.label}</div>
            </div>
        )
    }
}